export default [
    {
        path: '/halls',
        name: 'indexHalls',
        meta: { title: 'indexHallsAdmin' },
        component: () => import('@/pages/halls'),
    },
    {
        path: "/halls/reservation/:id",
        name: "hallsReservation",
        meta: { title: 'hallsReservation' },
        component: () => import('@/pages/halls/reservation'),
    },
]